import { useState, useEffect } from 'react';
import { privacyApi } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield } from 'lucide-react';

export default function Datenschutz() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    privacyApi.get()
      .then(res => setContent(res.data.content || ''))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-3xl mx-auto py-12 px-6 animate-fade-in" data-testid="datenschutz-page">
      <div className="flex items-center gap-3 mb-8">
        <div className="h-10 w-10 rounded-lg bg-secondary flex items-center justify-center">
          <Shield className="h-5 w-5 text-muted-foreground" />
        </div>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Datenschutzerklärung</h1>
          <p className="text-sm text-muted-foreground">Informationen zum Datenschutz</p>
        </div>
      </div>
      <Card>
        <CardContent className="p-6">
          {loading ? (
            <p className="text-muted-foreground text-sm py-12 text-center">Laden...</p>
          ) : content ? (
            <div className="prose prose-sm max-w-none text-foreground" dangerouslySetInnerHTML={{ __html: content.replace(/\n/g, '<br/>') }} data-testid="privacy-content" />
          ) : (
            <p className="text-muted-foreground text-sm py-12 text-center">
              Die Datenschutzerklärung wurde noch nicht hinterlegt. Bitte wenden Sie sich an den Administrator.
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
